export default "__VITE_ASSET__RVAITEHN__"